import styled from 'styled-components';

const SmallGrayText = styled.span`
  color: rgba(23, 60, 81, 0.5);
  font-size: 12px;
`;

export default SmallGrayText;
